export const POSTE_LOGIN_ROUTES = {
  posteLoginBusiness: "/poste-login-business",
  posteLoginBpiol: "/poste-login-bpiol"
} as const

export const ROUTES = {
  dashboard: "/",
  profile: "/profile",
  signup: "/signup",
  signupSuccess: "/signup-success"
}

export type PosteLoginRoutes = (typeof POSTE_LOGIN_ROUTES)["posteLoginBusiness" | "posteLoginBpiol"]
